import { render } from "./AnExamDetails.vue?vue&type=template&id=cd64e938"
import script from "./AnExamDetails.vue?vue&type=script&lang=js"
export * from "./AnExamDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../DEV/_vue3/reactive-clinic/rc-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__